export class FetchMeterReadingAction {
  static readonly type = '[Electric Meter] Fetch Meter Readings';

  constructor(public kcId: string) {
  }
}
